<template>
  <div :class="$style.frameParent">
    <div v-if="loading" class="loading-overlay">
      <b-spinner
        label="Loading..."
        variant="primary"
        class="spinner"
      ></b-spinner>
    </div>
    <h2 :class="$style.financingOptions">{{ title }}</h2>

    <div :class="$style.howDoYouPlanToPayForFliParent" readonly="missingQuote">
      <label :class="$style.howDoYou"
        >How do you plan to pay for flight school?</label
      >
      <div :class="$style.chooseOneParent">
        <HiloSelect
          :theme="'grey'"
          v-model="form.financingMethodId"
          :options="[
            { id: 1, name: 'Cash' },
            { id: 4, name: 'Financing' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{
            height: '50px',
            width: '100%',
            padding: '10px',
          }"
        />
      </div>
    </div>

    <!-- This section will only show if 'Financing' is selected -->
    <div v-if="isFinancingSelected">
      <div :class="$style.seeAvailableFinancingOptionParent">
        <b :class="$style.seeAvailableFinancing"
          >See Available Financing Options</b
        >
        <div :class="$style.inOrderTo">
          In order to see available financing options, we’ll need more
          information.
        </div>
      </div>

      <div :class="$style.frameGroup">
        <div :class="$style.frameContainer" :style="$global.dynamicCols(2)">
          <div :class="$style.fieldContainer">
            <label :class="$style.howDoYou">Tuition amount</label>
            <input
              v-model="form.tuitionAmount"
              type="number"
              placeholder="Type tuition amount..."
              readonly
            />
          </div>
          <div :class="$style.fieldContainer">
            <label :class="$style.howDoYou">Loan amount</label>
            <input
              v-model="form.loanAmount"
              type="number"
              placeholder="Type loan amount..."
            />
          </div>
        </div>
      </div>

      <div :class="$style.howDoYouPlanToPayForFliParent">
        <label for="ssn" :class="$style.howDoYou">9 Digit SSN...</label>
        <div :class="$style.typeTuitionAmountWrapper">
          <input
            id="ssn"
            :type="ssnInputType"
            :value="formattedSSN"
            @input="formatSSN"
            maxlength="11"
            placeholder="9 Digit SSN..."
          />
          <img
            alt="eyeball"
            src="/static/img/ViewPassword.svg"
            @click="toggleSSNPrivacy"
          />
        </div>
      </div>

      <div :class="$style.checkBoxParent">
        <input
          type="checkbox"
          id="coSignerCheck"
          :class="$style.checkBox"
          v-model="addCosigner"
          required
        />
        <label :class="$style.checkTheBox" for="coSignerCheck">
          Check if you would like to add a cosigner.
        </label>
      </div>

      <div :class="$style.cosignerParent" v-if="addCosigner">
        <label for="co-signer" :class="$style.cosigner">Cosigner</label>
        <div :class="$style.frameContainer" :style="$global.dynamicCols(2)">
          <input
            v-model="form.coSignerFirstName"
            type="text"
            placeholder="First name..."
          />
          <input
            v-model="form.coSignerLastName"
            type="text"
            placeholder="Last name..."
          />
        </div>
        <input
          v-model="form.coSignerAddress"
          type="text"
          id="co-signer"
          placeholder="Address..."
        />
        <div :class="$style.frameContainer" :style="$global.dynamicCols(3)">
          <input
            v-model="form.coSignerCity"
            type="text"
            placeholder="City..."
          />
          <input
            v-model="form.coSignerState"
            type="text"
            placeholder="State..."
          />
          <input v-model="form.coSignerZip" type="text" placeholder="Zip..." />
        </div>
        <div :class="$style.frameContainer" :style="$global.dynamicCols(2)">
          <input
            v-model="form.coSignerPhone"
            type="text"
            placeholder="Phone number..."
          />
          <input
            v-model="form.coSignerEmail"
            type="text"
            placeholder="Email..."
          />
        </div>
        <div :class="$style.relationshipParent">
          <HiloSelect
            :theme="'grey'"
            v-model="form.coSignerRelationshipId"
            :options="this.relationships"
            :placeholder="'Relationship...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>
        <div :class="$style.nameWrapper">
          <input
            :type="cosignerSsnInputType"
            id="co-signer-ssn"
            placeholder="9 Digit SSN..."
            :value="formattedCosignerSSN"
            @input="formatCosignerSSN"
            maxlength="11"
          />
          <img
            alt="eyeball"
            src="/static/img/ViewPassword.svg"
            @click="toggleCosignerSSNPrivacy"
          />
        </div>
      </div>

      <div :class="$style.checkBoxParent">
        <input
          type="checkbox"
          id="softCreditCheck"
          :class="$style.checkBox"
          v-model="form.softCreditCheck"
          required
        />
        <label :class="$style.checkTheBox" for="softCreditCheck">
          Check the box to allow us to perform a soft credit check and provide
          you with lenders willing to fund your student tuition.
        </label>
      </div>
    </div>

    <div :class="$style.buttonContainer">
      <div :class="$style.nextButton" @click="handleNext">
        <b :class="$style.name">Next</b>
      </div>
      <div :class="$style.backButton" @click="$emit('onPrev')">
        <b :class="$style.name">Back</b>
      </div>
    </div>

    <div :class="$style.frameDiv" />
  </div>
</template>

<script>
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService.js";
import SignUpAPIService from "@/servicehandlers/SignUpAPIService.js";
import QuotesAPIService from "@/servicehandlers/QuotesAPIService.js";
import CryptoJS from "crypto-js";
const encryptionKey = process.env.VUE_APP_ENCRYPTION_SECRET;
const aboutYouAPIService = new AboutYouAPIService();
const signUpAPIService = new SignUpAPIService();
const quotesAPIService = new QuotesAPIService();
import get from "lodash/get";

export default {
  components: { HiloSelect },
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isShow: false,
      relationships: null,
      ssnInputType: "password",
      cosignerSsnInputType: "password",
      form: {
        financingMethodId: null,
        tuitionAmount: null,
        loanAmount: null,
        coSignerFirstName: null,
        coSignerLastName: null,
        coSignerAddress: null,
        coSignerCity: null,
        coSignerState: null,
        coSignerZip: null,
        coSignerPhone: null,
        coSignerEmail: null,
        coSignerRelationshipId: null,
        softCreditCheck: null,
        ssn: "",
        coSignerSsn: "",
      },
      addCosigner: false,
      missingQuote: true,
      loading: false,
      emailRegex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      phoneRegex: /^(?:\(\d{3}\)\s?|\d{3}[-\s]?)\d{3}[-\s]?\d{4}$/,
      validations: [
        { field: "financingMethodId", desc: "financing method response" },
        { field: "tuitionAmount", desc: "tuition amount response" },
        { field: "loanAmount", desc: "loan amount response" },
        { field: "ssn", desc: "ssn" },
        { field: "coSignerFirstName", desc: "cosigner first name" },
        { field: "coSignerLastName", desc: "cosigner last name" },
        { field: "coSignerAddress", desc: "cosigner address" },
        { field: "coSignerCity", desc: "cosigner city" },
        { field: "coSignerState", desc: "cosigner state" },
        { field: "coSignerZip", desc: "cosigner zip" },
        {
          field: "coSignerPhone",
          regex: "phoneRegex",
          desc: "cosigner phone",
        },
        {
          field: "coSignerEmail",
          regex: "emailRegex",
          desc: "cosigner email",
        },
        { field: "coSignerRelationshipId", desc: "cosigner relationship" },
        { field: "coSignerSsn", desc: "cosigner ssn" },
        { field: "softCreditCheck" },
      ],
    };
  },
  watch: {
    addCosigner(newValue) {
      if (!newValue) {
        this.resetCosignerFields();
      }
    },
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getRelationships();
      await this.getFinancingOptionsSavedData();
      await this.getQuoteData();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  computed: {
    isFinancingSelected() {
      return this.form.financingMethodId === 4; // Show form if 'Financing' (ID: 4) is selected
    },
    formattedSSN() {
      if (!this.form.ssn) {
        return "";
      }
      const numbers = this.form.ssn.replace(/\D/g, "");
      const parts = [];
      parts.push(numbers.slice(0, 3));
      parts.push(numbers.slice(3, 5));
      parts.push(numbers.slice(5, 9));
      return parts.filter((part) => part).join("-");
    },
    formattedCosignerSSN() {
      if (!this.form.coSignerSsn) {
        return "";
      }
      const numbers = this.form.coSignerSsn.replace(/\D/g, "");
      const parts = [];
      parts.push(numbers.slice(0, 3));
      parts.push(numbers.slice(3, 5));
      parts.push(numbers.slice(5, 9));
      return parts.filter((part) => part).join("-");
    },
  },
  methods: {
    async encryptData(value) {
      if (!value) return "";
      return CryptoJS.AES.encrypt(value, encryptionKey).toString();
    },
    async decryptData(encryptedValue) {
      if (!encryptedValue) return "";
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedValue, encryptionKey);
        return bytes.toString(CryptoJS.enc.Utf8) || ""; // Ensure a string is returned
      } catch (error) {
        return "";
      }
    },
    async getFinancingOptionsSavedData() {
      try {
        const fetchedData = await signUpAPIService.getUserFinancing(
          this.userId,
        );
        if (
          fetchedData.coSignerPhone &&
          fetchedData.coSignerPhone.trim() !== ""
        ) {
          this.addCosigner = true;
        }
        if (fetchedData) {
          this.form = {
            ...this.form,
            ...fetchedData,
            ssn: await this.decryptData(fetchedData.ssn),
            coSignerSsn: await this.decryptData(fetchedData.coSignerSsn),
          };
        }
      } catch (error) {}
    },
    async getRelationships() {
      this.relationships = await aboutYouAPIService.getRelationshipsList();

      this.relationships = this.relationships.filter(
        (relationship) => relationship.financingStudent,
      );
    },
    async getQuoteData() {
      try {
        const quote = await quotesAPIService.getByUserId(this.userId);

        if (!quote || Object.keys(quote).length === 0) {
          alert(
            "A quote has not been completed yet and must be done before proceeding. Contact your flight school. Click Ok to return to the previous page.",
          );
          this.$emit("onPrev");
          return;
        }
        this.missingQuote = false;
        this.form.tuitionAmount = this.totalProgramPrice(quote);
      } catch (error) {
        alert("There was an error retrieving the quote data.");
      }
    },
    totalProgramPrice(quote) {
      return (
        (parseFloat(quote.privatePrice) || 0) +
        (parseFloat(quote.instrumentPrice) || 0) +
        (parseFloat(quote.commercialPrice) || 0) +
        (parseFloat(quote.cfiPrice) || 0) +
        (parseFloat(quote.cfiiPrice) || 0) +
        (parseFloat(quote.commMultiPrice) || 0) +
        (parseFloat(quote.meiPrice) || 0) +
        (parseFloat(quote.crewPrice) || 0) +
        (parseFloat(quote.simPrice) || 0)
      );
    },
    resetCosignerFields() {
      this.form.coSignerFirstName = "";
      this.form.coSignerLastName = "";
      this.form.coSignerAddress = "";
      this.form.coSignerCity = "";
      this.form.coSignerState = "";
      this.form.coSignerZip = "";
      this.form.coSignerPhone = "";
      this.form.coSignerEmail = "";
      this.form.coSignerRelationshipId = null;
      this.form.coSignerSsn = "";
    },
    async handleNext() {
      let isValid = true;

      for (const validation of this.validations) {
        if (this.form.financingMethodId === 1) {
          // If users selects cash, bypass validation
          break;
        }
        const { field, desc, regex } = validation;
        const fieldValue = get(this.form, field);
        const isCosignerField = field.startsWith("coSigner");

        if (isCosignerField && !this.addCosigner) {
          continue;
        }

        if (
          field !== "softCreditCheck" &&
          (fieldValue === undefined ||
            fieldValue === null ||
            fieldValue === "" ||
            (Array.isArray(fieldValue) && fieldValue.length === 0))
        ) {
          isValid = false;
          alert(`Please enter a ${desc}`);
          break;
        }

        if (field === "softCreditCheck" && !fieldValue) {
          isValid = false;
          alert(`Please check the box to allow a soft credit check.`);
          break;
        }

        if (regex && this[regex] && !this[regex].test(fieldValue)) {
          isValid = false;
          alert(`Please enter a valid ${desc}`);
          break;
        }
      }

      if (!isValid) return;
      await this.saveFinancingData();
    },
    async saveFinancingData() {
      try {
        this.loading = true;
        const financingData = {
          ...this.form,
          userId: this.userId,
          ssn: await this.encryptData(this.form.ssn),
          coSignerSsn: await this.encryptData(this.form.coSignerSsn),
        };
        await signUpAPIService.saveUserFinancing(this.userId, financingData);
        this.$emit("onNext", { financingOptions: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    formatSSN(event) {
      this.form.ssn = event.target.value;
    },
    formatCosignerSSN(event) {
      this.form.coSignerSsn = event.target.value;
    },
    toggleSSNPrivacy() {
      switch (this.ssnInputType) {
        case "password":
          this.ssnInputType = "text";
          break;
        case "text":
          this.ssnInputType = "password";
          break;
      }
    },
    toggleCosignerSSNPrivacy() {
      switch (this.cosignerSsnInputType) {
        case "password":
          this.cosignerSsnInputType = "text";
          break;
        case "text":
          this.cosignerSsnInputType = "password";
          break;
      }
    },
  },
};
</script>
<style module scoped>
.buttonContainer {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr;
  width: 100%;
}

.buttonContainer div {
  width: 100%;
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
.financingOptions {
  align-self: stretch;
  position: relative;
  font-size: 45px;
}

.howDoYou,
.cosigner {
  position: relative;
  font-size: 15px;
}

.cosigner {
  color: #404040;
  margin: 20px 0 -5px;
}

.chooseOneParent,
.typeTuitionAmountWrapper,
.nameWrapper,
.relationshipParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
}

.fieldContainer {
  height: 50px;
  margin-bottom: 40px;
}

.howDoYouPlanToPayForFliParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.seeAvailableFinancing {
  align-self: stretch;
  position: relative;
  font-weight: bold;
  font-size: 22px;
}

.inOrderTo {
  align-self: stretch;
  position: relative;
  font-size: 12px;
  margin-bottom: 10px;
}

.seeAvailableFinancingOptionParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.frameGroup {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px;
}

.frameContainer {
  width: 100%;
  display: grid;
  gap: 10px;
}

.cosignerParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  color: rgba(64, 64, 64, 0.5);
}

.checkBox {
  width: 19px;
  position: relative;
  border-radius: 5px;
  height: 19px;
  overflow: hidden;
  flex-shrink: 0;
}

.checkTheBox {
  margin: 0;
  font-size: 11px;
  line-height: 12px;
}

.checkBoxParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 15px;
  color: rgba(64, 64, 64, 0.75);
  margin-top: 20px;
}

.frameDiv {
  width: 100px;
  position: relative;
  background-color: #fff;
  height: 100px;
  overflow: hidden;
  flex-shrink: 0;
}

.frameParent {
  height: 100%;
  width: 100%;
  position: relative;
  background-color: #fff;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 25px;
  text-align: left;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
  overflow: hidden;
}
</style>
